module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_header_dress-c032951a03146da6b89c4d4c1340258d.svg";